import Dropdown from "@/components/forms/Dropdown";
import FormInput from "@/components/forms/Input";
import PageInner from "@/layouts/PageInner";
import { ContactMutationInput, ContactPage as ContactPageType, useContactMutation } from "graphql/generated-types";
import { useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";

export default function ContactPage({ data }: { data: ContactPageType }) {
	const { handleSubmit, setError, setValue, control } = useForm<ContactMutationInput>();

	const [contactMutation] = useContactMutation();

	const [submitted, setSubmitted] = useState(false);

	useEffect(() => {
		setValue("pageId", data.id ? parseInt(data.id) : 0);
	}, [data.id, setValue]);
	const onSubmit: SubmitHandler<ContactMutationInput> = async (data) => {
		contactMutation({
			variables: {
				input: data,
			},
		}).then(({ data, errors }) => {
			if (data?.contact?.errors && data.contact.errors.length > 0) {
				data.contact.errors.forEach((error) => {
					if (!error) return;

					error.messages.forEach((message) => {
						setError(error.field as keyof ContactMutationInput, {
							type: "manual",
							message: message,
						});
					});
				});
			} else {
				setSubmitted(true);
				window.scrollTo({
					top: 0,
					behavior: "smooth",
				});
			}
		});
	};
	return (
		<PageInner>
			<div className="mt-20 grid w-full md:grid-cols-3 md:gap-10 lg:mt-56">
				<div className="md:col-span-1">
					<h1 className="block-title leading-none">{data.title}</h1>
				</div>
				<div className="mt-8 md:col-span-2 md:mt-10">
					{submitted ? (
						<div className="prose" dangerouslySetInnerHTML={{ __html: data.thankYouText }} />
					) : (
						<form className="flex flex-col gap-10" onSubmit={handleSubmit(onSubmit)}>
							<FormInput label="pageId" type="hidden" formKey="pageId" control={control} />
							<div className="grid gap-10 md:grid-cols-2">
								<FormInput label="First name" type="text" formKey="firstName" control={control} />
								<FormInput label="Surname" type="text" formKey="surname" control={control} />
								<FormInput label="Email address" type="email" formKey="email" control={control} />
								<FormInput label="Phone number (optional)" type="text" formKey="phoneNumber" control={control} />
							</div>
							<Dropdown label="I am a" formKey="role" options={data.roles} control={control} />
							<Dropdown label="My enquiry is about" formKey="subject" options={data.subjects} control={control} />
							<FormInput label="Message" type="textarea" formKey="message" control={control} />
							<button className="decoration-cyan cursor-pointer self-start text-[24px] underline decoration-2 underline-offset-4">
								Submit
							</button>
						</form>
					)}
				</div>
			</div>
		</PageInner>
	);
}
